// extracted by mini-css-extract-plugin
module.exports = {"MESSAGES":"Messages_MESSAGES__32GJX","MESSAGES__empty_cart":"Messages_MESSAGES__empty_cart__3ksOH"};